export const SITE = {
  name: "ERRAH",
  tagline: "PROTECT WHAT MATTERS",
  domain: "www.theerrah.com",
  whatsapp: "919870575577",
  phone: "+919870575577",
  email: "care@theerrah.com",
  supportEmail: "support@theerrah.com",
  instagram: "https://instagram.com/the_errah",
  city: "Noida / Delhi NCR",
};

export const waLink = (text) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text || "Hi ERRAH, I'd like to protect my surfaces.")}`;
